import { formReducer } from 'redux-pure-form';
import { combineReducers } from 'redux';
import { omit } from 'lodash';

import {
  GET_AGENDA,
  GET_EVENT_REQUEST,
  GET_EVENT_FAILED,
  GET_EVENT,
  ADD_EVENT,
  ADD_EVENT_REQUEST,
  ADD_EVENT_FAILED,
  ADD_EVENT_SUCCESS,
  SAVE_EVENT,
  MOVE_EVENT,
  SAVE_EVENT_SUCCESS,
  CANCEL_EVENT,
  DELETE_EVENT_REQUEST,
  DELETE_EVENT_FAILED,
  DELETE_EVENT,
  CHECKOUT_EVENT_REQUEST,
  CHECKOUT_EVENT_FAILED,
  CHECKOUT_EVENT,
  CANCEL_CHECKOUT_EVENT_REQUEST,
  CANCEL_CHECKOUT_EVENT_FAILED,
  CANCEL_CHECKOUT_EVENT,
  CHECKIN_EVENT_REQUEST,
  CHECKIN_EVENT_FAILED,
  CHECKIN_EVENT,
  CANCEL_CHECKIN_EVENT_REQUEST,
  CANCEL_CHECKIN_EVENT_FAILED,
  CANCEL_CHECKIN_EVENT,
  GET_CALENDAR_EVENTS_REQUEST,
  GET_CALENDAR_EVENTS,
  GET_FILTER_DATA_START,
  GET_FILTER_DATA_FINISH,
  GET_INSTRUCTOR_BLOCK_EVENTS,
  GET_INSTRUCTOR_BLOCK_EVENTS_FAILED,
  GET_INSTRUCTOR_BLOCK_EVENTS_REQUEST,
  GET_INSTRUCTOR_SCHEDULE,
  GET_INSTRUCTOR_SCHEDULE_FAILED,
  GET_INSTRUCTOR_SCHEDULE_REQUEST,
  RESET_INSTRUCTOR_BLOCK_TIME,
  GET_TIMEZONE_REQUEST,
  GET_TIMEZONE_SUCCESS
} from '../actions/calendar.js';

import { GET_EVENT_COUNTERS_HISTORY } from '../actions/resource.js';

import { LOGOUT, RESET_CACHE } from '../actions-types/login-action-types.js';

const initStateCalendarReducer = {
  events: {},
  calendarEventsList: [],
  instructorBlockSchedule: [],
  instructorBlockEvents: [],
  timezones: {}
};

function Calendar(_state = initStateCalendarReducer, action) {
  let state = _state;
  if (action && action.payload && action.payload.data && action.payload.data.events) {
    state = {
      ..._state,
      events: {
        ..._state.events,
        ...Object.keys(action.payload.data.events).reduce((acc, key) => {
          return {
            ...acc,
            [key]: {
              ...(_state.events[key] || {}),
              ...action.payload.data.events[key]
            }
          };
        }, {})
      }
    };
  }
  if (action && action.payload && action.payload.data && action.payload.data.changedEvents) {
    state = {
      ..._state,
      events: {
        ..._state.events,
        ...Object.keys(action.payload.data.changedEvents).reduce((acc, key) => {
          return {
            ...acc,
            [key]: {
              ...(_state.events[key] || {}),
              ...action.payload.data.changedEvents[key]
            }
          };
        }, {})
      }
    };
  }


  switch (action.type) {
    case GET_TIMEZONE_REQUEST:
      return {
        ...state,
        isProgress: true,
        timezones: []
      };
    case GET_TIMEZONE_SUCCESS:
      return {
        ...state,
        isProgress: false,
        timezones: action.payload.data.data || {}
      };

    case GET_CALENDAR_EVENTS_REQUEST:
      return {
        ...state,
        isProgress: true,
        calendarEventsList: []
      };
    case GET_CALENDAR_EVENTS:
      return {
        ...state,
        isProgress: false,
        calendarEventsList: action.payload.data.eventsList || []
      };
    case GET_INSTRUCTOR_BLOCK_EVENTS_REQUEST:
      return {
        ...state,
        instructorBlockEvents: []
      };
    case GET_INSTRUCTOR_BLOCK_EVENTS:
      return {
        ...state,
        instructorBlockEvents: action.payload.data.busyTime || []
      };
    case GET_INSTRUCTOR_SCHEDULE_REQUEST:
      return {
        ...state,
        instructorBlockSchedule: []
      };
    case GET_INSTRUCTOR_SCHEDULE:
      return {
        ...state,
        instructorBlockSchedule: action.payload.data.notWorkingTime || []
      };
    case RESET_INSTRUCTOR_BLOCK_TIME:
      return {
        ...state,
        instructorBlockEvents: [],
        instructorBlockSchedule: []
      };
    case GET_AGENDA:
      return {
        ...state,
        agendaEventsList: action.payload.data.eventsList
      };
    case GET_EVENT:
      return {
        ...state,
        events: {
          ...state.events,
          [action.payload.data.event.id]: action.payload.data.event
        },
        isProgress: false
      };
    case GET_EVENT_REQUEST:
    case ADD_EVENT_REQUEST:
    case CHECKIN_EVENT_REQUEST:
    case CHECKOUT_EVENT_REQUEST:
    case CANCEL_CHECKOUT_EVENT_REQUEST:
    case DELETE_EVENT_REQUEST:
    case CANCEL_CHECKIN_EVENT_REQUEST:
      return {
        ...state,
        isProgress: true
      };
    case ADD_EVENT_FAILED:
    case CHECKIN_EVENT_FAILED:
    case CHECKOUT_EVENT_FAILED:
    case CANCEL_CHECKOUT_EVENT_FAILED:
    case DELETE_EVENT_FAILED:
    case CANCEL_CHECKIN_EVENT_FAILED:
    case GET_EVENT_FAILED:
      return {
        ...state,
        isProgress: false
      };
    case ADD_EVENT:
      return {
        ...state,
        isProgress: false,
        events: {
          ...state.events,
          [action.payload.data.event.id]: action.payload.data.event
        },
        calendarEventsList: state.calendarEventsList.concat(action.payload.data.event.id)
      };
    case MOVE_EVENT:
    case SAVE_EVENT:
      const id = action.payload.data.event.id;
      return {
        ...state,
        events: {
          ...state.events,
          [id]: {
            ...state.events[id],
            ...action.payload.data.event
          }
        }
      };
    case CANCEL_EVENT:
    case DELETE_EVENT:
      return {
        ...state,
        events: omit(state.events, action.meta.id),
        agendaEventsList: state.agendaEventsList.filter(
          eventID => parseInt(eventID, 10) !== parseInt(action.meta.id, 10)
        ),
        calendarEventsList: state.calendarEventsList.filter(
          eventID => parseInt(eventID, 10) !== parseInt(action.meta.id, 10)
        ),
        isProgress: false
      };
    case CHECKOUT_EVENT:
      return {
        ...state,
        events: {
          ...state.events,
          [action.meta.id]: {
            ...state.events[action.meta.id],
            checkOutEnable: '0',
            checkInEnable: '1',
            inFlight: '1'
          }
        },
        isProgress: false
      };
    case CANCEL_CHECKOUT_EVENT:
      return {
        ...state,
        events: {
          ...state.events,
          [action.meta.id]: {
            ...state.events[action.meta.id],
            checkOutEnable: '1',
            checkInEnable: '0',
            inFlight: '0'
          }
        },
        isProgress: false
      };
    case CHECKIN_EVENT:
      return {
        ...state,
        events: {
          ...state.events,
          [action.meta.id]: {
            ...state.events[action.meta.id],
            checkOutEnable: '0',
            checkInEnable: '0',
            inFlight: '0',
            completed: '1',
            customFields: action.meta.customFields,
            comments: action.meta.comments
          }
        },
        isProgress: false
      };
    case CANCEL_CHECKIN_EVENT:
      return {
        ...state,
        events: {
          ...state.events,
          [action.meta.id]: {
            ...state.events[action.meta.id],
            checkOutEnable: '0',
            checkInEnable: '1',
            inFlight: '1',
            completed: '0'
          }
        },
        isProgress: false
      };
    case GET_EVENT_COUNTERS_HISTORY:
      const eventID = action.meta.eventID;
      return {
        ...state,
        events: {
          ...state.events,
          [eventID]: {
            ...state.events[eventID],
            counters: [...action.payload.counters]
          }
        }
      };
    case LOGOUT:
    case RESET_CACHE:
      return initStateCalendarReducer;
    default:
      return state;
  }
}

const EventFormReducer = formReducer('event');
const EventCheckinReducer = formReducer('checkin');
const FilterReducer = formReducer('filter');

function Event(state = {}, action) {
  switch (action.type) {
    case GET_CALENDAR_EVENTS:
    case CHECKIN_EVENT:
    case ADD_EVENT_SUCCESS:
    case SAVE_EVENT_SUCCESS:
    case GET_CALENDAR_EVENTS_REQUEST:
      return {
        ...state,
        event: null,
        checkin: null
      };
    case GET_EVENT:
      return {
        ...state,
        event: null,
        checkin: null
      };
    case LOGOUT:
    case RESET_CACHE:
      return {};
    default:
      return EventCheckinReducer(EventFormReducer(state, action), action);
  }
}

function Filter(state = {}, action) {
  switch (action.type) {
    case GET_FILTER_DATA_START:
      return {
        ...state,
        isFilterProgress: true
      };
    case GET_FILTER_DATA_FINISH:
      return {
        ...state,
        isFilterProgress: false
      };
    case LOGOUT:
    case RESET_CACHE:
      return {};
    default:
      return FilterReducer(state, action);
  }
}

const CalendarReducer = combineReducers({
  Calendar,
  Event,
  Filter
});

export default CalendarReducer;

/**
 * select events by several functions
 * @param  {object} state      redux state
 * @param  {array}  eventsList events lists for filtering
 * @param  {array}  filters    filtering functions
 * @return {array}             filtered events list
 */
export function selectEventsBy(state, eventsList, ...filters) {
  if (Array.isArray(eventsList)) {
    return eventsList.filter(eventID =>
      filters.every(filter => filter(state.CalendarReducer.Calendar.events[eventID]))
    );
  }
  return [];
}

/**
 * select reducer by reducer name
 * @param  {object} state      redux state
 * @param  {reducerName}       name from select
 * @return {null|object}       state by name
 */
export function selectCalendarReducerByReducerName(state) {
  const calendar = state.CalendarReducer.Calendar;
  return reducerName => {
    if (!calendar) {
      return null;
    }
    return state.CalendarReducer.Calendar[reducerName];
  };
}
